module.exports = __webpack_public_path__ + "img/privacy-policy.ac4ff593.svg";